import React, { useState, forwardRef, useImperativeHandle } from "react";
import { useSelector } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import Stack from "../stack";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FullScreen = forwardRef((props, ref) => {
  const { title, headerRight, headerLeft } = props;

  const theme = useSelector((state) => state.theme);

  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    changeStatus() {
      handleChangeStatus();
    },
  }));

  const handleChangeStatus = () => {
    setOpen(!open);
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleChangeStatus}
      TransitionComponent={Transition}
      className={theme.isDarkTheme ? "dark" : ""}
    >
      <Stack
        title={title}
        headerRight={headerRight}
        headerLeft={headerLeft}
        handleChangeStatus={handleChangeStatus}
      />
      {props.children}
    </Dialog>
  );
});

export default FullScreen;
